// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"nft-details_Wrapper__O6vWQ","Label":"nft-details_Label__DHlQR","Value":"nft-details_Value__LD0gW","CopyButton":"nft-details_CopyButton__qXa6D"};